import React from "react";
import ar from "../../locale";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

const $ = window.$;
export default class ParentComponent extends React.Component {
  constructor(props, context) {
    super(props);
    this.$ = $;
  }

  componentDidMount() {
    $("#c_preloader").fadeOut();
  }

  componentWillUnmount() {}

  showError = (message, title = "") => {
    window.toastr.error(message, title, {
      positionClass: "toastr toast-top-center",
    });
  };

  showSuccess = (message, title = "") => {
    window.toastr.success(message, title, {
      positionClass: "toastr toast-top-center",
    });
  };

  confirm = (message, successcallback, cancelcallback) => {
    const options = {
      title: ar.please_confirm,
      message: message || ar.default_delete_message,
      buttons: [
        {
          label: ar.confirm,
          onClick: successcallback,
        },
        {
          label: ar.cancel,
          onClick: cancelcallback,
        },
      ],
      childrenElement: () => <div />,
      closeOnEscape: true,
      closeOnClickOutside: false,
      willUnmount: () => {},
      onClickOutside: () => {},
      onKeypressEscape: () => {},
    };
    confirmAlert(options);
  };
}
